module.exports = __webpack_public_path__ + "img/016.f6fcbe97.png";